<script>
/**
 * Auth-2 component
 */
export default {
  data () {
    return {};
  },
};
</script>

<template>
  <div class="auth-fluid">
    <!-- Auth fluid right content -->
    <div class="auth-fluid-right">
      <div class="auth-user-testimonial">
        <h3 class="mb-3 text-white">歡迎使用 !</h3>
        <p class="lead font-weight-normal">
          <i class="mdi mdi-format-quote-open"></i> 歡迎來到法語鸚鵡螺，您最貼心的法語學習夥伴！透過系統化影片課程與心智圖輔助，循序漸進打好語法與詞彙基礎，並提供 YouTube 免費試聽
          A1/A2 系列，快速體驗教學品質；搭配母語老師示範音檔，精準矯正發音；提交錄音作業，獲得專業回饋；瀏覽豐富部落格文章與小測驗，深入探索法國文化；聆聽法國職人
          Podcast，感受生活脈動；下載專屬講義與練習題，隨時複習檢測。立即註冊，與法語鸚鵡螺一起展開流利自信的法語之旅！
          <i class="mdi mdi-format-quote-close"></i>
        </p>
        <h5 class="text-white">- CHATGPT</h5>
      </div>
      <!-- end auth-user-testimonial-->
    </div>
    <!-- end Auth fluid right content -->

    <!--Auth fluid left content -->
    <div class="auth-fluid-form-box">
      <div class="align-items-center d-flex h-100">
        <div class="card-body">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
.auth-fluid {}
</style>